// extracted by mini-css-extract-plugin
export default {"container":"Articles_container__SzqB3","paragraph":"Articles_paragraph__DIYh-","bold":"Articles_bold__fOejq"};